// Carga y expone la configuración central del juego.
// El NOMBRE del juego y todos los ajustes viven en src/data/config.json.
import configData from '../data/config.json';

// Copia mutable en memoria (los ajustes de usuario pueden sobrescribir parte).
const config = structuredClone(configData);

export function getConfig() {
  return config;
}

/** Nombre visible del juego (cambiable en un único sitio: config.json). */
export const GAME_NAME = config.game.name;
export const GAME_SUBTITLE = config.game.subtitle;
export const GAME_TAGLINE = config.game.tagline;

/** Fusiona ajustes persistidos del usuario sobre la config por defecto. */
export function applyUserSettings(userSettings = {}) {
  if (userSettings.audio) Object.assign(config.audio, userSettings.audio);
  if (userSettings.accessibility) Object.assign(config.accessibility, userSettings.accessibility);
  if (userSettings.graphics) Object.assign(config.graphics, userSettings.graphics);
  return config;
}
